export const loadScript = (src, position, callBack) => {
    if (!position) {
      return
    }
    // Check if the script already exists
    const existingScript = document.querySelector(`script[src="${src}"]`)
    if (existingScript) {
      if (callBack) callBack() // Call the callback if provided
      return
    }
    const script = document.createElement('script')
    script.src = src
    position.appendChild(script)
    script.onload = () => {
      if (callBack) callBack()
    }
    script.onerror = () => {
      console.error(`Failed to load script: ${src}`)
    }
  }
  export const addScript = (loaded, scriptSrc, callBack) => {
    if (typeof window !== 'undefined' && !loaded.current) {
      loadScript(scriptSrc, document.querySelector('head'), callBack)
    }
  }